import React, { useEffect } from 'react';

import { connect, useDispatch } from 'react-redux';

import { getProfile } from '../../../redux/actions/aeMyProfile';

import { RestrictedPage } from '../../../components/atoms';
import { JobDetails } from '../../../components/templates';

function AppliedJobsPage({ my_profile }) {
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    const profile = async () => {
      dispatch(getProfile())
        .then(() => {})
        .catch(() => {});
    };

    profile();
  }, []);

  return <div>{['admin', 'finance'].includes(my_profile?.data?.data?.user?.user_type) ? <RestrictedPage /> : <JobDetails />}</div>;
}

AppliedJobsPage.getInitialProps = async (ctx) => ({ isServer: ctx.isServer });

const mapStateToProps = ({ currentUser: { data }, my_profile }) => ({ currentUser: data, my_profile });

export default connect(mapStateToProps, {})(AppliedJobsPage);
